// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"154":"4e300090","254":"24c3156b","441":"fc92dd50","520":"ce2da0bb","582":"968783d4","631":"240783c0"}[chunkId] + ".chunk.js";
};